import { render, staticRenderFns } from "./fulfillment.vue?vue&type=template&id=ac219714&scoped=true&"
import script from "./fulfillment.vue?vue&type=script&lang=js&"
export * from "./fulfillment.vue?vue&type=script&lang=js&"
import style0 from "./fulfillment.vue?vue&type=style&index=0&id=ac219714&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac219714",
  null
  
)

export default component.exports